import React, { useMemo } from "react";
import { ArrowUpRight } from "lucide-react";

// Calm, natural starter lines — at most 3 per intent.
export const STARTERS = {
    apologize: [
        "I'm sorry for…",
        "Apologies for the delay…",
        "I should have handled this better…",
    ],
    follow_up: [
        "Just checking in on…",
        "Wanted to follow up regarding…",
        "Any update on this?",
    ],
    set_boundary: [
        "I won't be able to take this on right now…",
        "I need to focus on my current priorities…",
        "I'd prefer to handle this at a later time…",
    ],
    ask_favor: [
        "Could you please help me with…",
        "Would you mind taking a look at…",
        "I'd really appreciate your help with…",
    ],
    clarify: [
        "Just to clarify…",
        "I want to make sure I understand correctly…",
        "Could you confirm if…",
    ],
    express_concern: [
        "I'm a bit concerned about…",
        "I wanted to flag something important…",
        "This might need some attention…",
    ],
    love: [
        "Just wanted you to know I…",
        "I really appreciate the way you…",
        "Thinking of you — I…",
    ],
};

// Pick `n` random items from an array (non-destructive, Fisher-Yates partial).
function pickRandom(arr, n) {
    const copy = arr.slice();
    const out = [];
    const take = Math.min(n, copy.length);
    for (let i = 0; i < take; i++) {
        const idx = Math.floor(Math.random() * copy.length);
        out.push(copy.splice(idx, 1)[0]);
    }
    return out;
}

const IntentStarters = ({ intent, onPick }) => {
    // Show 3 starters (the full pool in a random order) — reshuffled whenever
    // the active intent changes so the ordering feels fresh.
    const items = useMemo(() => {
        const pool = STARTERS[intent];
        if (!pool || pool.length === 0) return [];
        return pickRandom(pool, 3);
    }, [intent]);

    if (items.length === 0) return null;

    return (
        <div
            data-testid="intent-starters"
            data-intent={intent}
            className="w-full overflow-x-auto no-scrollbar"
        >
            <div className="flex flex-wrap sm:flex-nowrap items-stretch gap-1.5 sm:gap-2 px-1 py-1 sm:min-w-max">
                {items.map((s, i) => (
                    <button
                        key={`${intent}-${i}-${s}`}
                        type="button"
                        data-testid={`intent-starter-${i}`}
                        onClick={() => onPick(s)}
                        className="group shrink-0 inline-flex items-center gap-1.5 text-[12.5px] leading-snug font-normal text-foreground/75 hover:text-foreground bg-card hover:bg-muted/70 border border-border rounded-full pl-3 pr-2.5 py-1.5 transition-colors text-left"
                    >
                        <span>{s}</span>
                        <ArrowUpRight className="h-3 w-3 text-muted-foreground/60 group-hover:text-[#5E7153] transition-colors" />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default IntentStarters;
